import type { JSX } from 'solid-js';
import { SquadSettings } from '../components/SquadSettings';
import { SESSION_TOKEN } from '../lib/session';

// `/account/squads` (#6780, #7010 D12): the org's squads, beside Members in Settings and
// linked from the Repos header. The screen is `<SquadSettings/>`; `token` is injectable
// for tests.

export function Squads(props: { token?: string | null } = {}): JSX.Element {
  return (
    <section class="page">
      <SquadSettings token={props.token === undefined ? SESSION_TOKEN : props.token} />
    </section>
  );
}
